import styled from '@emotion/styled/macro';
import { Variables } from '../../base/variables';

export const SectionContainer = styled.div`
    padding: 16px;
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: 4px;
    background-color: ${Variables.Colors.white};
    margin-bottom: 16px;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const SectionTitle = styled.h3`
    font-size: 16px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
    margin: 0;
`;

export const DeleteButton = styled.button`
    padding: 6px 12px;
    background-color: ${Variables.Colors.warning};
    color: ${Variables.Colors.white};
    border: none;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        background-color: #d32f2f;
    }

    &:active {
        background-color: #b71c1c;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
`;

export const AddButton = styled.button<{ disabled?: boolean }>`
    padding: 8px 16px;
    background-color: ${props => (props.disabled ? Variables.Colors.n15 : Variables.Colors.b300)};
    color: ${props => (props.disabled ? Variables.Colors.n50 : Variables.Colors.white)};
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    transition: background-color 0.2s;

    &:hover {
        background-color: ${props => (props.disabled ? Variables.Colors.n15 : Variables.Colors.b400)};
    }

    &:active {
        background-color: ${props => (props.disabled ? Variables.Colors.n15 : Variables.Colors.b500)};
    }
`;


